import { ArrowBackIos } from "@mui/icons-material";
import { Box, Button, CircularProgress, Divider, IconButton, Paper, Typography } from "@mui/material";

interface ScaffoldProps {
    title: string;
    actions: JSX.Element[];
    isLoading?: boolean;
    mainAction?: JSX.Element | null;
    secondaryAction?: JSX.Element | null;
    children: JSX.Element;
    showBackButton?: boolean;
}

export default function Scaffold(props: ScaffoldProps) {
    return (
        <Box>
            <Paper elevation={0}>
                <Box className="flex justify-between">
                    <Box className="flex p-4">
                        {props.showBackButton && (<IconButton size="medium" onClick={() => window.history.back()}>
                            <ArrowBackIos/>
                        </IconButton>)}
                        <Typography  fontSize={22} fontWeight="bold" className="mt-1">
                            {props.title}
                        </Typography>
                    </Box>
                    <Box className="px-4 pt-4">
                        {props.isLoading && <CircularProgress size={28} />}
                    </Box>
                </Box>
                <Divide />
                {(props.actions.length > 0 || props.mainAction) && (
                    <Box>
                        <Box className="flex justify-between py-3 px-4 border-b-2">
                            <Box className="flex justify-start space-x-2">
                                {props.actions.map((action, index) => (
                                    <Box key={index}>{action}</Box>
                                ))}
                            </Box>
                            {props.mainAction}
                        </Box>
                        {props.secondaryAction && (
                            <Box className="px-4 pb-2 pt-1 mt-1">
                                {props.secondaryAction}
                            </Box>
                        )}
                    </Box>
                )}
            </Paper>
            <Divide />
            <Box className="p-4">{props.children}</Box>
        </Box>
    )
}

function Divide() {
    return <div className="bg-gray-300" style={{ height: '0.4px' }}></div>
}